import React from 'react';
import MediaCard from './MediaCard';
import './MediaGrid.css';

function MediaGrid({ media, selectedMedia, onSelectMedia, onDeleteMedia, onUpdateMedia, loading }) {
    if (loading) {
        return (
            <div className="media-grid-loading">
                <div className="spinner"></div>
                <p>Chargement des médias...</p>
            </div>
        );
    }

    if (!media || media.length === 0) {
        return (
            <div className="media-grid-empty">
                <svg
                    width="64"
                    height="64"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                </svg>
                <h3>Aucun média</h3>
                <p>Commencez par uploader votre première image</p>
            </div>
        );
    }

    return (
        <div className="media-grid">
            {media.map((item) => (
                <MediaCard
                    key={item.id}
                    media={item}
                    isSelected={selectedMedia?.id === item.id}
                    onSelect={onSelectMedia}
                    onDelete={onDeleteMedia}
                    onUpdate={onUpdateMedia}
                />
            ))}
        </div>
    );
}

export default MediaGrid;
